<template>
  <div>
    <SelectorPanel
      text="Watch"
      type="dashboard"
      :hide-panel="true"
      :disabled="disabled"
      @click="handleClick"
    >
    </SelectorPanel>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashDebounce from "lodash/debounce";
import { mapGetters } from "vuex";

import { MODULE_PREFIX_HOME, MODULE_PREFIX_USER } from "@/store";
import { GET_DETAILS_SIDEBAR } from "@/store/actions.type";
import { GRIDS_STABILITY_TYPES } from "@/common/constants/grids";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import { DEFAULT_COUNTRY_CODE } from "@/common/constants/home";

const EMITTED_ACTIONS = {
  CLICK: "click",
};

export default {
  name: "MonitorSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      preferences: MODULE_PREFIX_USER + "preferences",
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
    }),
  },
  methods: {
    handleClick() {
      this.openWatch();
      this.$emit(EMITTED_ACTIONS.CLICK);
    },
    openWatch() {
      let type = GRIDS_STABILITY_TYPES.country;
      let code = DEFAULT_COUNTRY_CODE;

      if (
        lodashGet(this.preferences, "watch.type") &&
        lodashGet(this.preferences, "watch.code")
      ) {
        type = this.preferences.watch.type;
        code = this.preferences.watch.code;
      }
      const bounceTime = this.detailsSidebar.visible ? 500 : 0;
      lodashDebounce(() => {
        this.detailsSidebar.selected = DETAIL_SIDEBAR_TYPES.monitor;
        this.detailsSidebar.type = DETAIL_SIDEBAR_TYPES.monitor;
        this.detailsSidebar.monitorType = DETAIL_SIDEBAR_TYPES.stability;
        this.detailsSidebar.stabilityType = type;
        this.detailsSidebar.code = code;
        this.detailsSidebar.openMonitor = true;
        this.detailsSidebar.visible = true;
        this.$store.dispatch(
          MODULE_PREFIX_HOME + GET_DETAILS_SIDEBAR,
          this.detailsSidebar
        );
      }, bounceTime)();
    },
  },
};
</script>

<style></style>
